
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/enternow/3a",
      function () {
        return require("private-next-pages/enternow/3a.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/enternow/3a"])
      });
    }
  